var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21.094,
    viewBox: "0 0 30 21.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M30.423,7.8a3.77,3.77,0,0,0-2.652-2.67C25.431,4.5,16.05,4.5,16.05,4.5s-9.381,0-11.721.631A3.77,3.77,0,0,0,1.677,7.8a39.544,39.544,0,0,0-.627,7.268,39.544,39.544,0,0,0,.627,7.268,3.713,3.713,0,0,0,2.652,2.627c2.34.631,11.721.631,11.721.631s9.381,0,11.721-.631a3.713,3.713,0,0,0,2.652-2.627,39.544,39.544,0,0,0,.627-7.268A39.544,39.544,0,0,0,30.423,7.8ZM12.982,19.529V10.608l7.841,4.461-7.841,4.46Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b2f6be3da65e893758e7697c5f01d5fb.svg";
export { ForwardRef as ReactComponent };